import { component } from "picoapp";

const COUNTRY_INPUT_SELECTOR = "[name='address[country]']";
const PROVINCE_INPUT_SELECTOR = "[name='address[province]']";

export const customerAddresses = component((node) => {
  const provinceMap = new Map();
  const addAddressToggleButtons = node.querySelectorAll<HTMLButtonElement>(
    "[data-add-address-toggle] button"
  );
  const editAddressToggleButtons = node.querySelectorAll<HTMLButtonElement>(
    "[data-edit-address-toggle] button"
  );
  const newAddressForm =
    node.querySelector<HTMLFormElement>("#address_form_new");
  const newAddressContainer =
    node.querySelector<HTMLFormElement>("[data-new-address]");
  const addresses = node.querySelector<HTMLElement>("[data-addresses]");
  const paginationContainer =
    node.querySelector<HTMLElement>("[data-pagination]");

  const toggleAddAddressForm = () => {
    newAddressContainer.classList.toggle("tw-hidden");
    addresses.classList.toggle("tw-hidden");
    paginationContainer.classList.toggle("tw-hidden");

    if (!newAddressContainer.classList.contains("tw-hidden")) {
      addProvinces(newAddressForm);
    }
  };

  const toggleEditAddressForm = (e: MouseEvent & { target: HTMLElement }) => {
    const addressId = e.target.closest<HTMLElement>(
      "[data-edit-address-toggle]"
    )?.dataset.editAddressToggle;
    const addressContainer = node.querySelector(
      `[data-address-id="${addressId}"]`
    );
    addressContainer.classList.toggle("tw-hidden");
    addresses.classList.toggle("tw-hidden");
    paginationContainer.classList.toggle("tw-hidden");

    if (!addressContainer.classList.contains("tw-hidden")) {
      const form = addressContainer.querySelector<HTMLFormElement>("form");
      addProvinces(form);
    }
  };

  const addProvinces = async (form: HTMLFormElement) => {
    const countrySelect = form.querySelector<HTMLSelectElement>(
      COUNTRY_INPUT_SELECTOR
    );
    const provinceSelect = form.querySelector<HTMLSelectElement>(
      PROVINCE_INPUT_SELECTOR
    );
    const provinceContainer = form.querySelector<HTMLElement>(
      "[data-province-container]"
    );
    const zipContainer = form.querySelector<HTMLElement>(
      "[data-zip-container]"
    );

    const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    let provinces: string[][] = provinceMap.get(selectedCountry.value);

    if (!provinces) {
      const provincesData = selectedCountry.dataset.provinces;
      if (!provincesData) return;
      provinces = await JSON.parse(provincesData);
      provinceMap.set(countrySelect.value, provinces);
    }

    if (!provinces || !provinces.length) {
      // Selected Country has no province
      provinceContainer.classList.add("tw-hidden");
      zipContainer.classList.replace("tw-col-span-1", "tw-col-span-2");
    } else {
      // Add provinces from currently selected country
      provinceContainer.classList.remove("tw-hidden");
      // Empty province select options
      provinceSelect.innerHTML = "";
      zipContainer.classList.replace("tw-col-span-2", "tw-col-span-1");
      const currentOption = provinceSelect.dataset.default;
      provinces.forEach((subProvinces) => {
        const province = subProvinces[subProvinces.length - 1];
        const provinceOption = document.createElement("option");
        provinceOption.value = province;
        provinceOption.innerHTML = province;
        if (currentOption === province) provinceOption.selected = true
        provinceSelect.appendChild(provinceOption);
      });
    }
  };

  const changeProvinces = (e: Event) => {
    const countrySelector = <HTMLSelectElement>e.currentTarget;
    addProvinces(countrySelector.form);
  };

  [...addAddressToggleButtons].forEach((button) => {
    button.addEventListener("click", toggleAddAddressForm);
  });
  [...editAddressToggleButtons].forEach((button) => {
    button.addEventListener("click", toggleEditAddressForm);
  });

  node
    .querySelectorAll<HTMLSelectElement>(COUNTRY_INPUT_SELECTOR)
    .forEach((select) => {
      select.addEventListener("change", changeProvinces);
      const selectedCountry = select.dataset.default;
      if (selectedCountry) {
        for (let i = 0, count = select.options.length; i < count; i++) {
          const option = select.options[i];
          if (selectedCountry === option.value || selectedCountry === option.innerHTML) {
            select.selectedIndex = i;
          }
        }
      }
    });

  return () => {
    [...addAddressToggleButtons].forEach((button) => {
      button.removeEventListener("click", toggleAddAddressForm);
    });
    [...editAddressToggleButtons].forEach((button) => {
      button.removeEventListener("click", toggleEditAddressForm);
    });
    node
      .querySelectorAll<HTMLSelectElement>(COUNTRY_INPUT_SELECTOR)
      .forEach((select) => {
        select.removeEventListener("change", changeProvinces);
      });
  };
});
